import React from "react";
import { Customer } from "./types/restaurant";
import CommonTable from "../../../../grocery/components/CommonTable";

interface CustomerTableProps {
  customers: Customer[];
  onSelectCustomer: (id: string) => void;
}

interface TableRowData {
  id: string | number;
  SNo: number;
  Name: string;
  Phone: string;
}

const CustomerTable: React.FC<CustomerTableProps> = ({ customers, onSelectCustomer }) => {
  const tableData: TableRowData[] = customers.map((c, index) => ({ id: c._id?.$oid || index, SNo: index + 1, Name: c.Name || "-", Phone: c.phone_number || "-", }));

  const headCells: { id: keyof TableRowData; label: string }[] = [
    { id: "SNo", label: "S.No" },
    { id: "Name", label: "Customer Name" },
    { id: "Phone", label: "Phone Number" },
  ];

  return (
    <div className="thin-scrollbar flex-1 overflow-auto">
      <CommonTable<TableRowData>
        className="w-full min-w-[515px] max-w-[900px] h-[400px]"
        data={tableData}
        headCells={headCells}
        title="Customers"
        showToolbar={false}
        selectable={false}
        onRowClick={(id) => onSelectCustomer(String(id))}
        pageSize={10}
        pagenation={false}
      />
    </div>
  );
};

export default CustomerTable;
